<template>
  <div v-resize="onResize">
          
  <v-container>
    <v-layout class = "mr-5 mt-0 mb-0 ">
<!-- {{timeSchedule}} -->
<!-- {{$store.state.api}} -->
      <h1 style="margin-left:15px; margin-top :20px;font-family:Verdana;font-size:16px"> <v-icon >mdi-timer</v-icon> Time Schedule List</h1>
      <v-spacer></v-spacer>
        <v-col class="d-flex" cols="3" >
          <v-select
          v-model="searchCar"
        :items="filterRes"
        
        solo
        dense
        ></v-select>
    </v-col>
      <v-spacer></v-spacer>

      <v-btn @click="openDialog()" rounded outlined style="margin-top :15px; margin-right :10px;font-family:Verdana"> 
                      <v-icon>mdi-alarm-plus </v-icon>
                          Add New Time Schedule
                      </v-btn>
      
    </v-layout>
        <v-card>
<!-- {{filterTime}} -->
  <v-container fluid>  
      <v-simple-table dense fixed-header :height="windowSize.y - 170 " style="margin-top :-10px" >
      <thead>
          <tr>
              <th class="text-center" style = "color:black;font-family:Verdana;width:30%"> Time Display </th>
              <th class="text-center" style = "color:black;font-family:Verdana;width:15%"> Time </th>
              <th class="text-center" style = "color:black;font-family:Verdana;width:20%"> Use Special Only </th>    
              <th class="text-center" style = "color:black;font-family:Verdana;width:15%">Action</th>
              <th class="text-center" style = "color:black;font-family:Verdana;width:20%">View</th>
          </tr>
          </thead>
          <tbody>
              <tr v-for="item in filterTime" :key="item.timeID">
                  <td class="text-center" style = "color:black;font-family:Verdana">{{item.timeDisplay}}</td>
                  <td class="text-center" style = "color:black;font-family:Verdana">{{item.timeSched}}</td>
                  <td class="text-center"> <input type="checkbox" :checked="item.useSpecial" :disabled="true"></td>
                    <!-- <td class="text-center" style = "color:black;font-family:Verdana">{{item.useSpecial}}</td> -->
                    
                    <td class="text-center" style = "color:black;font-family:Verdana">
                      
                      <!-- <v-switch :input-value="item.useSpecial" dense style="margin-bottom:-50px;"></v-switch> -->
                      <v-tooltip bottom>
                        <template v-slot:activator= "{on}">

                      <v-btn v-on="on" elevation="0" x-small fab @click="editRec(item)">
                      <v-icon color="grey darken-1">mdi-pencil</v-icon>
                  </v-btn>
                        </template>
                        <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                      <template v-slot:activator= "{on}">
                  <v-btn v-on="on" elevation="0" x-small fab @click="deleteRec(item,item.timeID)">
                      <v-icon color="grey darken-1">mdi-trash-can-outline</v-icon>
                  </v-btn>
                  </template>
                    <span>Delete</span>
                  </v-tooltip>
                  
                    </td>
                    <td class="text-center" style = "color:black;font-family:Verdana">
                      <center>   <v-switch @change="useViewChange(item)" value :input-value="item.useView" dense :label="item.useView == true ? 'On' : 'Off'" style="margin-top :0px;  margin-bottom :-20px; margin-left :50px; margin-rigth:-50px"></v-switch> </center>
                    </td>
              </tr>
          </tbody>
          </v-simple-table>
      
    </v-container>
    

    <v-dialog v-model = "dialog" persistent width="350px">
    <v-card>
        <v-toolbar dense color="#213c57" dark> <v-icon>mdi-information-outline</v-icon>
          <span style = "font-family: Verdana;font-size:15px; margin-left :5px " > Time Schedule Information</span>
          <v-spacer></v-spacer>
            <v-btn icon @click = "closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-layout row>
              <v-row>
                  <v-col>
                    
                  <v-text-field v-model="toAdd.timeDisplay" outlined label = "Time Display" dense></v-text-field>
                  <v-text-field type="time" v-model="toAdd.timeSched" outlined label = "Time" dense ></v-text-field>
                <v-row>
                  <v-checkbox label= "Use Special Only" v-model="toAdd.useSpecial" style="margin-top :-15px" ></v-checkbox> 
                  <v-spacer></v-spacer>
                  <span style="margin-top :-10px; margin-right:5px">View:</span>
                  <v-switch  :label="toAdd.useView == true ? 'On' : 'Off'" v-model="toAdd.useView" style="margin-top :-15px"></v-switch>
                </v-row>
                  

              </v-col>
              </v-row>
            </v-layout>
          <v-layout>
          <v-spacer></v-spacer>

            <v-btn style = "margin-top:-25px" block @click = "addtimeSchedule()" color="success"> {{btnName}} </v-btn>
          </v-layout>
          </v-container>
        </v-card-text>
    </v-card>
    </v-dialog>
    </v-card>
    <v-dialog v-model="serverDialog"  width="350" persistent>
      <v-card>
        <v-toolbar dense color="#213c57" dark> <v-icon>mdi-database</v-icon>
          <span style = "font-family: Verdana;font-size:15px; margin-left :5px " > SERVER</span>
          <v-spacer></v-spacer>
            <v-btn icon @click="serverDialog = !serverDialog; password = ''; disableRadio = true "><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        
        <v-card-text>
          <v-container>
            <v-layout row>
                <v-text-field v-model="password" outlined label="password" dense  
                append-outer-icon="mdi-send" @click:append-outer="checkpassword()"></v-text-field>
                <v-alert dense outlined type="error"  dismissible v-model="passwordAlert" transition="slide-x-transition">
                  Incorrect password
                </v-alert>
                <v-radio-group v-model="rowradio" row :disabled="disableRadio">
                  <v-radio @change="setAWSLink()" label="AWS server" value="AWS_LINK"  ></v-radio>
                  <v-radio @change="setLocalLink()"  label="Local server" value="LOCAL_LINK" ></v-radio>
                </v-radio-group>
            </v-layout>
          </v-container>
        </v-card-text>
      
      </v-card>
      
    </v-dialog>
    
    </v-container>
    
  </div>
</template>

<script>

// import axios from 'axios'
import api from '../api.js'
import _ from 'lodash'
import swal from 'sweetalert'
export default {
  components:{
      
  },
  created(){
    this.loadtimeSchedule()
  },
  data(){
      return{
        searchCar : 'All',
        dialog: false,
        timeSchedule:[],
        toAdd:{},
        filterRes :['All','Regular','Special'],
        btnName: '',
        serverDialog : false,
        password : '',
        rowradio : 'AWS_LINK',
        disableRadio : true,
        passwordAlert : false
      }
  },
  computed:{
      filterTime(){
        if(this.searchCar === 'Regular'){
          return this.timeSchedule.filter( rec => { 
            return rec.useSpecial === false
        })
        }else if(this.searchCar === 'Special'){
          return this.timeSchedule.filter(rec =>{
            return rec.useSpecial === true
          })
        }else{
          return this.timeSchedule
        }
      },
  },
  watch:{
      
  },
  methods: {
    setAWSLink(){
      this.rowradio = 'AWS_LINK'
      this.CHANGE_API_LINK('https://1ze9v428i9.execute-api.us-east-2.amazonaws.com/prod/')
      console.log(this.rowradio)
      this.loadtimeSchedule()
    },
    setLocalLink(){
      this.rowradio = 'LOCAL_LINK'
      this.CHANGE_API_LINK('http://10.169.141.109:3000/')
      console.log(this.rowradio)
      this.loadtimeSchedule()
    },
    openDialog(){
        this.dialog = true
        this.btnName = 'Add'
        this.toAdd.useSpecial = false
      },
      closeDialog(){
        this.dialog = false
        this.toAdd = {}
      },
      addtimeSchedule(){
          if(this.btnName === 'Add'){
            let url = `${this.api}addTimesched`
          api.post(url, this.toAdd).then (res =>{
            // this.employeedata = res.data
          console.log(res.data)
          swal( "New Time Schedule Added", " " , "success" , {
              timer: 1000,
              button:false
          })
            this.loadtimeSchedule()
          this.closeDialog()
            
          
        }) 
          }else {
            // console.log(this.toAdd)
            let url = `${this.api}updateTimeSched`
          api.put(url, this.toAdd).then (res =>{
            // this.employeedata = res.data
          console.log(res.data)
          swal( "Time Schedule has been updated", " " , "success" , {
              timer: 1000,
              button:false
          })
            this.loadtimeSchedule()
            this.closeDialog()
          })
          }
      
      },
      useViewChange(val){
      
        this.toAdd = val
        if(val.useView == true){
          this.toAdd.useView = false
          console.log(this.toAdd)
          let url = `${this.api}updateTimeSched`
          api.put(url,this.toAdd).then(res =>{
            
            if(res.data){
              console.log(res.data)
                swal( "Time Schedule has been updated", " " , "success" , {
              timer: 1000,
              button:false
            })
            }
            
          })
        }else{
          this.toAdd.useView = true
          console.log(this.toAdd)
          let url = `${this.api}updateTimeSched`
          api.put(url,this.toAdd).then(res =>{
            
            if(res.data){
                console.log(res.data)
                swal( "Time Schedule has been updated", " " , "success" , {
              timer: 1000,
              button:false
              })
            }
            
          })
        }
          
          
      },
      loadtimeSchedule(){
            let url =  `${this.api}getTimesched`
          api.get(url).then( res =>{
          //  this.timeSchedule = res.data

          this.timeSchedule = _.orderBy(res.data, ['timeDisplay'], ['ASC'])
          this.$socket.emit('cars_update', res.data )
        }) 
      },

        editRec(rec){
          
        this.dialog = true
        this.btnName = 'Update'
        this.toAdd = rec  
        
      
    },

    deleteRec(rec,timeID) {
      swal({
        title: 'Do you want to delete this Time Schedule?',
        icon : 'warning',
        closeOnEsc: false,
        closeOnClickOutside: false,
        buttons : [ 'No',  'Yes']
          
        }).then( (willApprove)=>{
            if (willApprove) {
              swal( "Time Schedule deleted", " " , "error" , {
              timer: 1000,
              button:false
              })
          const index = this.timeSchedule.indexOf(rec)          
          this.timeSchedule.splice(index,1)
          let url = `${this.api}deleteTimeSched`
          api.post(url,{timeID:timeID}).then( res => {
          console.log(res.data)
          this.loadtimeSchedule()
          }
          )
            }
        })
      
    },
    checkpassword(){
      if(this.password !== 'ssd_admin'){
        this.disableRadio = true;
        this.passwordAlert = true;
      }else{
        this.passwordAlert = false;
        this.disableRadio = false;
      }
    }
  }
}


</script>

<style scoped>
table,th,td {
border: 1px solid grey !important;
}
td{
padding: 3px !important;
}

th{  
  background-color: #213c57 !important;
  color:white !important;
  font-family: Arial !important;
  padding:15px !important;
  font-size:13px;
}
tr:hover {
background-color: #cdcdd1 !important;
}

</style>


